module.exports = __webpack_public_path__ + "img/grade_A.933ccf4.svg";